import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as R from 'ramda'

import { Book } from 'types/books'

import {
  buildBookChapterUrl,
  buildBookSectionUrl
} from '../utils/buildBookNavigationUrl'

type NavigateToBookChapterParams = {
  studentBookId: string
  chapterOrder: number
  part?: number
}

type NavigateToBookSectionParams = {
  studentBookId: string
  chapterOrder: number
  sectionPart?: number
  sectionId: string
}

const getOriginalBookId = (
  books: Book[],
  booksNavigation: Book[],
  studentBookId: string
): string => {
  const bookFromList = books.find(book => book.id === studentBookId)
  const bookFromNavigation = booksNavigation.find(
    book => book.id === studentBookId
  )
  const book = bookFromList ?? bookFromNavigation

  return book?.book_id ?? book?.original_book_id ?? ''
}

export const useNavigateToQuizDiagnosticsBook = () => {
  const { push } = useHistory()
  const books = useSelector(R.pathOr<Book[]>([], ['books', 'books', 'list']))
  const booksNavigation = useSelector(
    R.pathOr<Book[]>([], ['books', 'booksNavigation'])
  )

  const navigateToBookChapter = useCallback(
    ({ studentBookId, chapterOrder, part }: NavigateToBookChapterParams) => {
      const originalBookId = getOriginalBookId(
        books,
        booksNavigation,
        studentBookId
      )

      if (!originalBookId || !chapterOrder) {
        return
      }

      push(
        buildBookChapterUrl({
          originalBookId,
          chapterOrder,
          part
        })
      )
    },
    [books, booksNavigation, push]
  )

  const navigateToBookSection = useCallback(
    ({
      studentBookId,
      chapterOrder,
      sectionPart,
      sectionId
    }: NavigateToBookSectionParams) => {
      const originalBookId = getOriginalBookId(
        books,
        booksNavigation,
        studentBookId
      )

      if (!originalBookId || !sectionId || !chapterOrder) {
        return
      }

      push(
        buildBookSectionUrl({
          originalBookId,
          chapterOrder,
          sectionPart,
          sectionId
        })
      )
    },
    [books, booksNavigation, push]
  )

  return { navigateToBookChapter, navigateToBookSection }
}
